// ** React Imports
import { Suspense, lazy } from "react"
import ReactDOM from "react-dom"

// ** Redux Imports
import { Provider } from "react-redux"
import { store } from "./redux/storeConfig/store"

// ** Toast & ThemeColors Context
import { ToastContainer } from "react-toastify"
import { ThemeContext } from "./utility/context/ThemeColors"

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner"

// ** Ripple Button
import "./@core/components/ripple-button"

// ** PrismJS
import "prismjs"
import "prismjs/themes/prism-tomorrow.css"
import "prismjs/components/prism-jsx.min"

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css"

// ** React Toastify
import "@styles/react/libs/toastify/toastify.scss"

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css"
import "./@core/assets/fonts/GothamMedium/font.css"
import "./@core/assets/fonts/GothamBook/font.css"
import "./@core/assets/fonts/Montserrat/font.css"
import "./@core/scss/core.scss"
import "./assets/scss/style.scss"

// ** Service Worker
import * as serviceWorker from "./serviceWorker"

//** Nestble
import "react-nestable/dist/styles/index.css"
import { BrowserRouter } from "react-router-dom"

// ** Lazy load app
const LazyApp = lazy(() => import("./App"))
const removeLoader = () => {
  const loader = document.getElementById('page-loader')
  if (loader) {    
    loader.style.display = 'none'
    const app = document.getElementById('root')
    app.style.display = "block"
  }
}
const waitForResourcesToLoad = () => {
  return new Promise((resolve) => {
    window.addEventListener('load', () => {
      resolve()
    })
  })
}
const renderApp = async () => {
  if (window.self !== window.top) {
    await waitForResourcesToLoad().then(() => {
      removeLoader()
      window.parent.postMessage({ type: 'LOADER_STATUS', value: false }, '*')
    })
  }

  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <Suspense fallback={<Spinner />}>
          <ThemeContext>
            <LazyApp />
            <ToastContainer newestOnTop />
          </ThemeContext>
        </Suspense>
      </BrowserRouter>
    </Provider>,
    document.getElementById("root")
  )
}
renderApp()
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
